import api from '../services/api';
import { createBaseModule } from './base';

export default createBaseModule( {
  state: {
    
  },
  mutations: {

  },
  actions: {
    async fetchOrder({ commit, state }, id) {

      commit('RESET_STATE');

      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await api.get('api/order/'+id+'/');
        commit('SET_DATA', {data:response.data.data});
        commit('SET_ERROR', null);
      } catch (error) {
        commit('SET_ERROR', error.message?error.message:'Ошибка при загрузке');
      } finally {
        commit('SET_LOADING', false);
      }
    },
    updateLocalQuantity({ commit }, quantity) {
      commit('SET_LOCAL_QUANTITY', quantity);
    }

  },
  getters: {
    order: state => state.data,
    orderLoading: state => state.loading,
    orderError: state => state.error,
    orderLoaded: state => state.loaded,
    localQuantity: state => state.localQuantity
  }
})